import { HttpClient, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { HttpErrorService } from '../http-error.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { FirmwareUpgradeRequest } from 'src/app/app.types';

@Injectable({
  providedIn: 'root'
})
export class FirmwareManagementService {
  /**
   * CTOR
   * @param {HttpClient} http
   * @param {ConfigService} configService
   * @param {HttpErrorService} httpErrorService
   */
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private httpErrorService: HttpErrorService,
    private toastrService: ToastrService
  ) {}
  
  /**
   * Get Firmware Files
   * @returns {Observable<any>}
   */
  getFiles() {
    return this.http.get(this.configService.API_URI + '/Firmwares/GetFiles').pipe(
      catchError((err) => {
        this.httpErrorService.handleHttpError(err);
        return of(err);
      })
    );
  }
  
  /**
   * Update Firmware on list of devices
   * @returns {Observable<any>}
   * @param firmwareUpgradeRequest
   */
  upgradeFirmware(firmwareUpgradeRequest: FirmwareUpgradeRequest) {
    const url = this.configService.API_URI + '/Firmwares/UpdateFirmware';
    const req = new HttpRequest('POST', url, firmwareUpgradeRequest);

    return this.http.request(req).pipe(
      map((res) => {
        if (res instanceof HttpResponse) {
          this.toastrService.success('Request to upgrade devices successfully sent.', 'Success');
          return res;
        }
      }),
      catchError((err) => {
        this.httpErrorService.handleHttpError(err);
        return of(err);
      })
    );
  }
}
